import formatDate from 'utils/date/formatDate';
import { IChartData } from '../Chart.types';

export const serializeData = (data: IChartData) => {
  const series = data?.series?.[0]?.data || [];
  const dates = data?.dates?.map(chartPoint => formatDate(chartPoint, { ms: true })) || [];

  return { series, dates };
};
